import type { SVGProps } from "react";
const SvgSchool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M5.833 18.333V10.23c0-.902 0-1.352.204-1.73.204-.379.578-.622 1.327-1.11L9.1 6.26c.437-.284.656-.427.901-.427s.464.143.901.428l1.735 1.13c.749.487 1.123.73 1.327 1.108s.204.83.204 1.73v8.104"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M10 10.833h.008"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M16.667 18.333v-4.031c0-1.91-.787-2.064-2.5-2.635M3.333 18.333v-4.031c0-1.91.787-2.064 2.5-2.635M1.667 18.333h16.666M10 5.833V4.152m0 0V2.475c0-.395 0-.592.122-.715.383-.386 1.961.526 2.562.895.506.313.65.936.65 1.497zM8.333 18.333v-2.5c0-.785 0-1.178.244-1.422.245-.244.637-.244 1.423-.244s1.178 0 1.423.244c.244.244.244.637.244 1.422v2.5"
    />
  </svg>
);
export default SvgSchool;
